import * as React from 'react'
import { theme } from '../theme'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface Props {
    value: string
    onChange: (value: string) => void
    placeholder?: string
}

export const ArticleUrlInput = ({
    value,
    onChange,
    placeholder = 'Enter URL here'
}: Props) => {
    const [isFocused, setIsFocused] = React.useState(false)

    // Custom tooltip with higher z-index and simplified content
    const tooltip = (
        <Tooltip
            id="url-tooltip"
            style={{ zIndex: 9999 }}
        >
            <div>
                Our AI will analyze your article&apos;s content and automatically
                generate a relevant, photorealistic image optimized for native advertising.
            </div>
        </Tooltip>
    )

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing.sm,
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <label
                    style={{
                        margin: 0,
                        fontSize: '14px',
                        color: theme.colors.text.primary,
                        fontWeight: theme.typography.weights.medium,
                    }}
                >
                    Add URL for landing page
                </label>
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="right"
                    container={document.body}
                    overlay={tooltip}
                >
                    <i
                        className="fa fa-info-circle"
                        style={{
                            marginLeft: '8px',
                            color: theme.colors.primary,
                            cursor: 'pointer'
                        }}
                    />
                </OverlayTrigger>
            </div>
            <input
                type="url"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                placeholder={placeholder}
                style={{
                    width: '100%',
                    height: '36px',
                    padding: theme.spacing.sm,
                    borderRadius: theme.borderRadius.sm,
                    border: `1px solid ${isFocused ? theme.colors.primary : theme.colors.border}`,
                    backgroundColor: theme.colors.background,
                    color: theme.colors.text.primary,
                    fontSize: '12px',
                    outline: 'none',
                }}
            />
        </div>
    )
}
